import moment from "moment";

export const parseDateToDaysAgo = (dateString) => {
  const date = moment(new Date(dateString));
  const today = moment();
  const diffDays = today.diff(date, "days");

  if (Number.isNaN(diffDays)) {
    return null;
  }
  if (diffDays <= 0) {
    return "Today";
  }
  return `${Math.min(diffDays, 7)} days ago`;
};

export const getButtonClassName = (className = "") => `block bg-black hover:bg-neutral-600 focus:bg-neutral-700 text-center px-4 py-2 text-white hover:text-white rounded-md cursor-pointer text-md ${className}`;
